import TextField from "@mui/material/TextField";
import "./TextInput.css";
 
const TextInput = (props) => {
  return <TextField size="small" className="input-style" sx={props.sx} {...props} />;
};
 
export default TextInput;
 
 